<div #visualObjectContainer>
  <div class="visual-object-margin bom-panel panel" [class.border-style]="!showTitle" [style.max-width.%]="'100'" >
    <gridview>
      <gridview-header classes="panel-header" *ngIf="showTitle">
        <header-columntemplate classes="header-image" size="auto">
          <co-image width="24" height="24" type="svg" key="bom" [imageSet]="imageSet"></co-image>
        </header-columntemplate>
        <header-columntemplate classes="header-title">
          {{panel.title}}
        </header-columntemplate>
        <header-columntemplate classes="text-right details-icon header-image" size="auto" title="{{strings.Details}}">
          <co-image width="32" height="32" type="svg" key="viewdetails" role="button" (click)="onBomCompositeClick()" [imageSet]="imageSet"></co-image>
        </header-columntemplate>
      </gridview-header>
    </gridview>

    <bom-panel-contents [panel]="panel" [confBomValue]="confBomValue" ></bom-panel-contents>
  </div>
</div>